const FndPermissionQueryFields = [
    {
        name: '权限组名称',
        code: 'name',
        column: true,
        defaultFilter: true,
        width: 300
    },
    {
        name: '描述',
        code: 'description',
        column: true,
        defaultFilter: true
    }
]
export default FndPermissionQueryFields;